// extracted by mini-css-extract-plugin
export default {"user-container":"styles_user-container__C32Dx","icon-button":"styles_icon-button__j8ugQ"};